"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var theme_1 = require("../../utils/theme");
var Button = (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, type = _b.type, size = _b.size, disabled = _b.disabled, testId = _b.testId, rest = tslib_1.__rest(_b, ["prefixCls", "className", "style", "type", "size", "disabled", "testId"]);
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-type-" + type] = type,
                _a[prefixCls + "-size-" + size] = size,
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            return (h("button", tslib_1.__assign({}, rest, { className: classes, style: style, disabled: disabled, "data-testid": testId }), _this.props.children));
        };
        return _this;
    }
    Button.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Button;
}(React.Component));
exports.default = Button;
Button.defaultProps = {
    prefixCls: 'dui-m-button',
    type: 'default',
    size: 'default'
};
